import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ApiService } from 'src/app/services/api/api.service';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-modal-market-interest-info',
  templateUrl: './modal-market-interest-info.component.html',
  styleUrls: ['./modal-market-interest-info.component.scss']
})
export class ModalMarketInterestInfoComponent implements OnInit {

  @ViewChild('marketInterestInfoModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  item: any = {};
  interest: any = {};
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private api: ApiService
  ) { }

  ngOnInit() {
    this.modalServ.onMarketInterestInfo.subscribe(req => {
      this.item = req.item;
       this.getProductInterestedInfo();
       if(!this.isShow) {this.show();}
    });

    this.modalServ.onMarketInterestInfoHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  confirm() {
    this.hide();
  }

  getProductInterestedInfo(): Promise<any> {
    return new Promise((resovle) => {
      this.api.getMarketPlaceInterestedInfo(this.item.ProductId).subscribe(res => {
        if (res.Code == 200) {
          this.interest = res.Results;
          resovle(res.Results);
        } else {
          resovle('');
        }
      }, err => {
        console.error(err);
        resovle('');
      });
    });
  }

}
